module.exports = __webpack_public_path__ + "static/mail-89746ed217e89f489d44aadba6a1a2ef.svg";